"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
exports.__esModule = true;
exports.claimSummary = exports.getSchemaFromClaimPartType = void 0;
var date_fns_1 = require("date-fns");
var schema_1 = require("../schema");
var stxt_1 = require("../stxt");
var number_format = require("locutus/php/strings/number_format");
var confirmationClaimProperties = __assign(__assign({}, schema_1.dereferencedSchema.components.schemas.Claim.allOf[1].properties), { status: undefined, originalPaperEmailClaimFileIds: undefined, adminUserId: undefined, internalComment: undefined, evaluatorUserId: undefined, finalReviewerUserId: undefined, isWidower: undefined, parts: undefined });
var mapping = schema_1.dereferencedSchema.components.schemas.Claim.allOf[1]
    .properties.parts.items.discriminator.mapping;
function getSchemaFromClaimPartType(claimPartType) {
    var ref = mapping[claimPartType];
    if (ref) {
        // @ts-ignore
        var _a = schema_1.dereferencedSchema.components.schemas[ref.split("/").pop()], allOf = _a.allOf, description = _a.description;
        return {
            description: description,
            properties: allOf.reduce(function (prev, schema) { return (__assign(__assign({}, prev), schema.properties)); }, {}),
            required: allOf.reduce(function (prev, schema) { return __spreadArrays(prev, (schema.required || [])); }, [])
        };
    }
    return {
        properties: {
            type: {
                type: "string"
            }
        },
        required: ["type"]
    };
}
exports.getSchemaFromClaimPartType = getSchemaFromClaimPartType;
function renderSchemaValue(schema, value) {
    switch (schema.type) {
        case "boolean":
            return stxt_1.stxt(value);
        case "array":
            return value.length + " " + (value.length === 1 ? "bestand" : "bestanden");
        case "string":
            if (schema["enum"]) {
                return stxt_1.stxt(value);
            }
            if (schema.format === "date") {
                return date_fns_1.format(new Date(value), "dd-MM-yyyy");
            }
    }
    return value;
}
var nl2br = function (str) {
    return String(str).replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, "$1<br>$2");
};
function renderClaimPart(claimPart) {
    var schema = getSchemaFromClaimPartType(claimPart.type);
    var claimPartProperties = schema.properties;
    return "<h5 class=\"mt-4\">" + schema.description + "</h5><table style=\"width: 100%\">" + Object.keys(claimPartProperties)
        .map(function (propertyName) {
        var confirmationProp = claimPartProperties[propertyName];
        var propValue = claimPart[propertyName];
        if (propertyName === "calculation") {
            return "\n          " + ((propValue === null || propValue === void 0 ? void 0 : propValue.amount) ? "<tr><td style=\"width:50%\">Toegekend bedrag</td><td>&euro; " + number_format(propValue.amount, 2, ",", ".") + "</td></tr>"
                : "") + "\n          " + ((propValue === null || propValue === void 0 ? void 0 : propValue.externalComment) ? "<tr valign=\"top\"><td style=\"width:50%\">WBF Opmerking</td><td>" + nl2br(propValue.externalComment) + "</td></tr>"
                : "") + "\n        ";
        }
        if (confirmationProp &&
            confirmationProp.description &&
            claimPart[propertyName]) {
            return "<tr valign=\"top\"><td style=\"width:50%\">" + nl2br(confirmationProp.description) + "</td><td>" + renderSchemaValue(confirmationProp, propValue) + "</td></tr>";
        }
        return "";
    })
        .join("") + "</table>";
}
function anonymizeClaimSummaryValue(value, propertyName) {
    var valueString = String(value);
    if (valueString.indexOf("@") > -1) {
        var _a = valueString.split("@"), prefix = _a[0], suffix = _a[1];
        return String(prefix).slice(0, 1) + "***" + String(prefix).slice(-2) + "@***" + String(suffix).slice(-4);
    }
    if (!isNaN(value) || String(propertyName) === "bankAccount") {
        return "**" + valueString.slice(-Math.min(4, valueString.length - 2));
    }
    if (valueString.match("[0-9]{2}-[0-9]{2}-[0-9]{4}")) {
        return valueString.slice(0, 6) + "****";
    }
    if (valueString.match("[0-9]{4} [A-Z]{2}")) {
        return valueString.slice(0, 2) + "** " + valueString.slice(-2);
    }
    return valueString
        .split(" ")
        .map(function (str) { return str.slice(0, 1).padEnd(str.length, "*"); })
        .join(" ");
}
function claimSummary(claim) {
    return "<h2>Samenvatting aanvraag</h2>\n<h3 class=\"mt-3\">Algemene gegevens</h3>\n<table style=\"width: 100%\">" + Object.keys(confirmationClaimProperties)
        .map(function (propertyName) {
        if (["street", "city", "bsn"].indexOf(propertyName) > -1) {
            return "";
        }
        var confirmationProp = confirmationClaimProperties[propertyName];
        if (claim &&
            confirmationProp &&
            confirmationProp.description &&
            claim[propertyName]) {
            return "<tr><td style=\"width:50%\">" + confirmationProp.description + "</td><td>" + anonymizeClaimSummaryValue(renderSchemaValue(confirmationProp, claim[propertyName]), propertyName) + "</td></tr>";
        }
        return "";
    })
        .join("") + "</table><h4 class=\"mt-3\">Inhoud aanvraag</h4>" + claim.parts
        .map(renderClaimPart)
        .join("");
}
exports.claimSummary = claimSummary;
